export const gradeConversion = (cumulativeScore) => {
    const gradeRanges = [
        { min: 90, max: 102, letter: 'A' },
        { min: 80, max: 89, letter: 'B' },
        { min: 70, max: 79, letter: 'C' },
        { min: 60, max: 69, letter: 'D' },
        { min: 0, max: 59, letter: 'F' }
    ];
    for (let i = 0; i < gradeRanges.length; i++) {
        const { min, max, letter } = gradeRanges[i];
        if (cumulativeScore >= min && cumulativeScore <= max) {
            return letter;
        }
    }
    return 'F';
};
export const formatNameToFile = (input) => {
    // Validate if a valid string is provided
    if (typeof input !== 'string') {
        return '';
    }
    // Convert to lowercase and replace spaces and special characters with _
    const result = input
        .toLowerCase()
        .replace(/[\s]+/g, '_')
        .replace(/[^\w-]+/g, '');
    // Validate if the result is empty after formatting
    if (result.length === 0) {
        return '';
    }
    return result;
};
export const getDueDateRealEstate = () => {
    const today = new Date();
    return `05/01/${today.getFullYear()}`;
};
export const getStatementDateRealEstate = () => {
    const today = new Date();
    return `04/25/${today.getFullYear()}`;
};
export const getFeeDateRealEstate = () => {
    const today = new Date();
    return `05/16/${today.getFullYear()}`;
};
export const getFeeDateRealEstate2 = () => {
    const today = new Date();
    return `05/15/${today.getFullYear()}`;
};
export const getFakeAccountNumberRealEstate = () => {
    // random 6 digit number
    return Math.floor(100000 + Math.random() * 900000).toString();
};
